/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { lazy, Suspense, useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
import theme from "assets/theme";

// Material Kit 2 React routes
import routes, { additionalRoutes } from "routes";

const Presentation = lazy(() => import("layouts/pages/presentation"));

/* Écran d'attente pendant le chargement du chunk d'une page. */
function PageFallback() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "var(--c-bg, #000)",
        color: "var(--c-text-dim, rgba(255,255,255,0.4))",
        fontFamily: '"Share Tech Mono", "Courier New", monospace',
        fontSize: "0.85rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      chargement...
    </div>
  );
}

export default function App() {
  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Suspense fallback={<PageFallback />}>
        <Routes>
          {getRoutes(routes)}
          {additionalRoutes && getRoutes(additionalRoutes)}
          <Route path="/" element={<Presentation />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Suspense>
    </ThemeProvider>
  );
}
